import Head from 'next/head'
import Link from 'next/link'
import React from 'react'

import { buildActionAnalyticsAttributes } from '@mondough/analytics-v2'
import { useCopy } from '@mondough/copy'
import { Title } from '@mondough/monzo-ui'

import { TabContext } from '../../providers/TabProvider'
import styles from './TabLayout.module.scss'
import { TabLayoutProps } from './TabLayout.types'
import { Button, Loading } from '..'

const TabLayout: React.FC<TabLayoutProps> = ({ children }: TabLayoutProps) => {
  const { tab, pageTitle, breadcrumb } = React.useContext(TabContext)
  const c = useCopy()

  if (!tab) {
    return <Loading />
  }

  return (
    <>
      <Head>
        <title>
          {c.string({
            key: 'app_tabs_monzo_me.default.page.title_with_tab',
            message: 'Monzo Split | {{ tabName }}',
            variables: {
              tabName: tab.name,
            },
          })}
        </title>
      </Head>
      <section className={styles.tab}>
        {breadcrumb.title && (
          <Link href={breadcrumb.href} legacyBehavior>
            <Button
              size="small"
              theme="invisible"
              icon="chevron-left"
              iconSize={14}
              className={styles['tab-breadcrumb']}
              {...buildActionAnalyticsAttributes('details-breadcrumb', {
                breadcrumb: breadcrumb.title,
              })}
            >
              {breadcrumb.title}
            </Button>
          </Link>
        )}
        {pageTitle && (
          <Title is="h1" size="medium" className={styles['tab-title']}>
            {pageTitle}
          </Title>
        )}
        <section className={styles['tab-content']}>{children}</section>
      </section>
    </>
  )
}

export default TabLayout
